import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

function load (component) {
  return () => import(`@/views/${component}.vue`)
}

export default new Router({
  routes: [
    {
      path: '/landing.html',
      name: 'landing',
      component: load('landing')
    },
    {
      path: '/belepes.html',
      name: 'login',
      component: load('auth/login')
    },
    {
      path: '/jelszo_modositasa.html',
      name: 'passwordChange',
      component: load('auth/ChangePassword')
    },

    // ## Error reports
    {
      path: '/rendszerhibak.html',
      name: 'error_report_list',
      component: load('errorReports/list')
    },
    {
      path: '/rendszerhibak/uj.html',
      name: 'error_report_new',
      component: load('errorReports/details')
    },
    {
      path: '/rendszerhibak/:errorReportId.html',
      name: 'error_report_details',
      component: load('errorReports/details'),
      props: true
    },

    // ## Events
    {
      path: '/esemenyek.html',
      name: 'event_list',
      component: load('events/list')
    },
    {
      path: '/esemenyek/uj.html',
      name: 'event_new',
      component: load('events/details')
    },
    {
      path: '/esemenyek/:eventId.html',
      name: 'event_details',
      component: load('events/details'),
      props: true
    },

    // ## Event templates
    {
      path: '/esemeny-sablonok.html',
      name: 'event_templates_list',
      component: load('eventTemplates/list')
    },
    {
      path: '/esemeny-sablonok/uj.html',
      name: 'new_event_template',
      component: load('eventTemplates/details')
    },
    {
      path: '/esemeny-sablonok/:eventTemplateId.html',
      name: 'event_templates_details',
      component: load('eventTemplates/details'),
      props: true
    },

    // ## Scheduled events
    {
      path: '/utemezett-esemenyek.html',
      name: 'scheduled_event_list',
      component: load('scheduledEvents/list')
    },
    {
      path: '/utemezett-esemenyek/:scheduledEventId.html',
      name: 'scheduled_event_details',
      component: load('scheduledEvents/details'),
      props: true
    },

    // ## Users
    {
      path: '/felhasznalok.html',
      name: 'user_list',
      component: load('users/list')
    },
    {
      path: '/felhasznalok/uj.html',
      name: 'user_new',
      component: load('users/details')
    },
    {
      path: '/felhasznalok/:userId.html',
      name: 'user_details',
      component: load('users/details'),
      props: true
    },

    // ## Groups
    {
      path: '/csoportok.html',
      name: 'group_list',
      component: load('groups/list')
    },
    {
      path: '/csoportok/uj.html',
      name: 'group_new',
      component: load('groups/details')
    },
    {
      path: '/csoportok/:groupId.html',
      name: 'group_details',
      component: load('groups/details'),
      props: true
    },

    {
      path: '/dokumentumtar.html',
      name: 'documents',
      component: load('documents/list')
    },

    // ## Partners
    {
      path: '/partnerek.html',
      name: 'partner_list',
      component: load('partners/list')
    },
    {
      path: '/partnerek/uj.html',
      name: 'partner_new',
      component: load('partners/details')
    },
    {
      path: '/partnerek/:partnerId.html',
      name: 'partner_details',
      component: load('partners/details'),
      props: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/commons/router.js